<template>
  <div>
    <div class="d-flex align-end mb-5">
      <EditAssignedUsersModal :group="group" :options="{ ...options, search }" />
      <div class="search-box">
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Wyszukaj" single-line hide-details />
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="assignedUsers.items"
      item-key="id"
      :options.sync="options"
      :server-items-length="assignedUsers.count"
      :loading="assignedUsers.loading"
      :footer-props="{
        'items-per-page-text': 'Ilość elementów na stronę:',
        'items-per-page-all-text': 'Wszystkie',
        'page-text': '{0}-{1} z {2}'
      }"
      no-data-text="Brak dostępnych danych"
      no-results-text="Brak dostępnych danych"
      loading-text="Ładowanie... Proszę czekać"
      disable-sort
      class="elevation-1"
      @removedElement="removedElement"
    >
      <template v-slot:item.dateFrom="{ item }">
        {{ item.dateFrom | date }}
      </template>
      <template v-slot:item.dateTo="{ item }">
        {{ item.dateTo | date }}
      </template>
      <template v-slot:item.actions="{ item }">
        <RemoveUserModal :user="item" :group="group" :options="{ ...options, search }" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EditAssignedUsersModal from '@/components/manage/groups/manage-group/assigned-users/EditAssignedUsersModal.vue';
import { createNamespacedHelpers } from 'vuex';
import RemoveUserModal from '@/components/manage/groups/manage-group/assigned-users/RemoveUserModal.vue';

const { mapActions, mapState } = createNamespacedHelpers('groups');
const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  components: {
    EditAssignedUsersModal,
    RemoveUserModal
  },
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      search: null,
      options: {}
    };
  },
  computed: {
    ...mapState({
      assignedUsers: state => state.groupAssignment.assignedUsers,
      unAssignedUsers: state => state.groupAssignment.unAssignedUsers
    }),
    ...mapAccountState(['token']),
    headers() {
      return [
        { text: 'Imię', value: 'name' },
        { text: 'Nazwisko', value: 'surname' },
        { text: 'E-mail', value: 'email' },
        { text: 'Akcje', value: 'actions' }
      ];
    }
  },
  watch: {
    search(val) {
      this.options.page = 1;
      this.getAssignedUsers({
        groupId: this.group.id,
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        search: val
      });
    },
    options: {
      handler(val) {
        this.getAssignedUsers({
          groupId: this.group.id,
          page: val.page,
          itemsPerPage: val.itemsPerPage,
          search: this.search
        });
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['getAssignedUsers']),
    removedElement() {
      if (this.assignedUsers.items.length === 0 && this.options.page > 1) {
        this.options.page--;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  width: 600px;
}
</style>
